import {Layout} from "antd";
import Text from "antd/lib/typography/Text";
import React, {FC, memo} from "react";
import {Link} from "react-router-dom";
import i18n from "../../services/i18n";
import {URL_LEGAL_NOTICE, URL_PRIVACY_POLICY} from "../../models/url";
import css from "./LoginFooter.less";

type LoginFooterProps = {
    children?: React.ReactNode;
    style?: React.CSSProperties;
};

const LoginFooter: FC<LoginFooterProps> = ({children, style}) => {
    const thisYear = new Date().getFullYear().toString();

    return (
        <Layout.Footer className={css.root} style={style}>
            <div className={css.content}>
                <Text>{i18n.containers.login.Login.footer({thisYear})}</Text>
                <Link to={URL_LEGAL_NOTICE}>
                    {i18n.containers.topLevelPage.TopLevelPage.legalNotice.title()}
                </Link>
                <Text>{" | "}</Text>
                <Link to={URL_PRIVACY_POLICY}>
                    {i18n.containers.topLevelPage.TopLevelPage.privacyNotice.title()}
                </Link>
            </div>
            {children}
        </Layout.Footer>
    );
};

export default memo(LoginFooter);
